<template>
  <b-modal
    v-model="kycVerifyModalData.isShow"
    ref="kycVerifyModalOnfido"
    centered
    size="md"
    :hide-footer="true"
    @hide="kycVerifyModalHidden"
    dialog-class="kycVerifyModalOnfido-dialog"
    header-class="kycVerifyModalOnfido-header"
    body-class="kycVerifyModalOnfido-body"
  >
    <template #modal-title>
      <h2 class="package-kycVerifyModalOnfido-title">{{ $t(kycVerifyModalTitle) }}</h2>
    </template>

    <template #modal-header-close>
      <i class="airalo-icon-close-round-filled tw-block tw-text-5.5 tw-mt-2.5 tw-mr-2.5" />
    </template>

    <div :class="['c--shared_kyc-verify-modal', { 'tw-p-5 tw-pb-10': showTips }]">
      <div v-if="showTips" class="kycVerifyModalOnfido-content" data-testid="eKYC-content">
        <template v-if="showDestinationAddress">
          <DestinationAddress @click="submitKyc" />
        </template>

        <template v-else>
          <VerificationTips
            :privacy-info="kycVerifyModalData.privacyInfo"
            :is-destination-address-required="kycVerifyModalData.isDestinationAddressRequired"
            kyc-provider="onfido"
            @click="checkDestinationAddressOrSubmitKyc"
          />
        </template>
      </div>

      <template v-else>
        <div id="onfido-mount" class="tw-h-[600px]" />
      </template>
    </div>
  </b-modal>
</template>

<script>
  import DestinationAddress from '@/components/shared/kyc-verify-modal/destination-address.vue'
  import VerificationTips from '@/components/shared/kyc-verify-modal/verification-tips/index.vue'

  export default {
    name: 'kyc-verify-modal_onfido',
    components: {
      DestinationAddress,
      VerificationTips,
    },
    data() {
      return {
        showTips: true,
        showDestinationAddress: false,
        transactionId: null,
        destinationAddress: '',
      }
    },
    computed: {
      kycVerifyModalData() {
        return this.$store.getters['eKyc/get_verify_modal_data']
      },
      kycVerifyModalTitle() {
        if (this.showTips) {
          if (this.showDestinationAddress) {
            return 'scenes.ekyc.destination-address.title'
          } else {
            return 'scenes.ekyc.tips.title'
          }
        } else {
          return 'scenes.ekyc.tips.navigation-title'
        }
      },
    },
    methods: {
      async requestKyc() {
        const requestData = {
          package_id: this.kycVerifyModalData.package_id || undefined,
        }

        if (this.kycVerifyModalData?.order_id) {
          requestData.order_id = this.kycVerifyModalData.order_id
        }

        if (this.kycVerifyModalData?.isDestinationAddressRequired) {
          requestData.destination = this.destinationAddress
        }

        try {
          const kycData = await this.$axios.$post('/v2/users/me/identities', requestData)

          if (kycData) {
            const { token, transaction_id } = kycData

            if (transaction_id) {
              this.transactionId = transaction_id
            }

            window.Onfido.init({
              token: token,
              containerId: 'onfido-mount',
              workflowRunId: transaction_id,
              // steps: ['welcome', 'document', 'face', 'complete'],
              language: this.$i18n.locale,
              onComplete: (value) => {
                this.updateStatus(this.transactionId)
              },
              onError: (error) => {
                console.error('an error occurred', error)
              },
            })
          }
        } catch (error) {
          console.error(error)

          let message = this.$t('global.network-error-title')
          const title = this.$t('global.error.title')

          if (error?.response?.data?.message) {
            message = error.response.data.message
          }

          this.$bvToast.toast(message, { title, variant: 'danger', solid: true })
          this.$refs.kycVerifyModalOnfido.hide()
        }
      },
      async updateStatus(transactionID) {
        try {
          await this.$axios.put('/v2/users/me/identities/' + transactionID, {}).then((response) => {
            if (this.kycVerifyModalData.type === 'my-esims') {
              this.kycVerifyModalData.isOneTime
                ? this.$store.dispatch('eKyc/fetch_user_identities')
                : this.$store.dispatch('eKyc/fetch_user_default_identities')

              this.$root.$emit('update-eSIM')
            } else {
              this.kycVerifyModalData.isOneTime
                ? this.$store.dispatch('eKyc/fetch_package_identity', this.kycVerifyModalData.package_id)
                : this.$store.dispatch('eKyc/fetch_user_default_identities')
            }

            this.kycVerifyModalHidden()

            this.$bvToast.toast(response.data.message, {
              title: this.$t('messages.success.title'),
              variant: 'success',
              solid: true,
            })
          })
        } catch (error) {
          this.$bvToast.toast(error.response.data.message, {
            title: this.$t('global.error.title'),
            variant: 'danger',
            solid: true,
          })
        }
      },
      kycVerifyModalHidden() {
        this.showTips = true
        this.showDestinationAddress = false
        this.transactionId = null
        this.$store.commit('eKyc/RESET_VERIFY_MODAL_DATA')
      },
      checkDestinationAddressOrSubmitKyc() {
        if (this.kycVerifyModalData.isDestinationAddressRequired) {
          this.showDestinationAddress = true
        } else {
          this.showTips = false
        }
      },
      submitKyc(destinationAddress) {
        this.destinationAddress = destinationAddress
        this.showTips = false
      },
    },
    watch: {
      showTips(val) {
        if (val) {
          this.modalSrc = ''
          this.transactionId = null
        } else {
          this.requestKyc()
        }
      },
    },
  }
</script>

<style lang="scss">
  #onfido-mount {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      border: 1px solid #fff;
      pointer-events: none;
    }
  }

  .kycVerifyModalOnfido-dialog .modal-header .close {
    [dir='rtl'] & {
      margin: -1rem auto -1rem -1rem;
    }
  }

  .kycVerifyModalOnfido-dialog {
    &.modal-md {
      max-width: 540px;
    }

    .modal-content {
      box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
      overflow: hidden;
    }
  }

  .kycVerifyModalOnfido-header {
    .package-kycVerifyModalOnfido-title {
      color: #4a4a4a;
      font-size: 21px;
      font-weight: 600;
      letter-spacing: -0.3px;
      line-height: 25px;
      margin: 24px 0 2px 4px;
    }

    button.close {
      padding: 0;
      opacity: 1;

      img {
        margin-top: 9px;
        margin-right: 9px;

        [dir='rtl'] & {
          margin-right: unset;
          margin-left: 9px;
        }
      }
    }
  }

  .kycVerifyModalOnfido-body {
    padding: 0;

    .kycVerifyModalOnfido-content {
      .tips-description {
        color: #8a8a8a;
        font-size: 15px;
        letter-spacing: 0;
        line-height: 21px;

        ul > li:not(:last-child) {
          margin-bottom: 20px;
        }
      }

      .kycVerifyModalOnfido-continueBtn {
        color: #ffffff;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 1px;
        line-height: 11px;
        text-align: center;
        padding: 16px 20px 15px;
      }
    }

    .embed-responsive {
      min-height: 70vh;
    }
  }
</style>
